import { useTranslation } from "react-i18next";
import { TabsToggle } from "@resideo/blueprint-oneportal";
import styles from "./ManageDevicesHeader.module.css";

export type DeviceTab =
  | "All Devices"
  | "Cameras"
  | "Thermostats";

export const DEVICE_TABS: readonly DeviceTab[] = [
  "All Devices",
  "Cameras",
  "Thermostats",
] as const;

// Translation keys for each tab label.
const TAB_LABEL_KEYS: Record<DeviceTab, string> = {
  "All Devices": "manageDevices.tabs.allDevices",
  Cameras: "manageDevices.tabs.cameras",
  Thermostats: "manageDevices.tabs.thermostats",
};
 
export interface ManageDevicesHeaderProps {
  activeTab: DeviceTab;
  onTabChange: (tab: DeviceTab) => void;
  // Hide the Cameras / Thermostats tabs when the account has no such devices.
  hasCameras?: boolean;
  hasThermostats?: boolean;
}

export const ManageDevicesHeader = ({
  activeTab,
  onTabChange,
  hasCameras = true,
  hasThermostats = true,
}: ManageDevicesHeaderProps) => {
  const { t } = useTranslation();

  const tabs = DEVICE_TABS.filter((tab) => {
    if (tab === "Cameras") return hasCameras;
    if (tab === "Thermostats") return hasThermostats;
    return true;
  });

  return (
    <div className={styles.headerWrapper}>
      <TabsToggle
        size="small"
        className={styles.tabs}
        aria-label={t("manageDevices.ariaLabels.deviceCategories")}
        items={tabs.map((tab) => ({
          label: t(TAB_LABEL_KEYS[tab]),
          value: tab,
        }))}
        value={activeTab}
        onChange={(value) => onTabChange(value as DeviceTab)}
      />
    </div>
  );
};

export default ManageDevicesHeader;